// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../../assets/stylesheets/variables.css\"","borderGrey":"#d5dfdf","textBlack":"#161616","errorRed":"#ff2a2a","caption":"_1dJD2pSCq2-UhXWE_3mRfd","input":"_1u2MZyPkbpKMsd7qPXj3w2","button":"_3pqkYGEI5kBXtvabrPXr8A","select":"czNNzB8vpf1_UDWYpuGMN","recaptcha":"_3KDeJPiMoL6yxuQVNjf4Ic","errorMessage":"_2kY3kkyedSgVSKNtnLREC4 _1dJD2pSCq2-UhXWE_3mRfd","error":"_1OP6UpmS3k5-dUzsJR5Zop _1dJD2pSCq2-UhXWE_3mRfd"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/register/data-form/DataForm.css
// module id = 871
// module chunks = 0